<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle de un prospecto</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
      <home-delete-button></home-delete-button>
    </template>
  </main-buttons-bar>

  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Código'"
        :spanColumn="4"
        :data="prospect.Codigo"
      ></custom-data>
      <custom-data
        :label="'Codigo Adicional '"
        :spanColumn="4"
        :data="prospect.CodigoSecundario ? prospect.CodigoSecundario : 'No informa'"
      ></custom-data>
      <custom-data
        :label="'Activo'"
        :spanColumn="4"
        :data="prospect.Activo === true ? 'Si' : 'No'"
      ></custom-data>
      <custom-data
        :label="'Fecha creacion'"
        :spanColumn="4"
        :data="prospect.FechaCreacion ? getDate('dd/mm/yyyy', prospect.FechaCreacion) : ''"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Descripción'"
        :spanColumn="14"
        :data="prospect.Descripcion"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Giro'"
        :spanColumn="4"
        :data="prospect.Giro ? prospect.Giro : 'No informa'"
      ></custom-data>
      <custom-data
        :label="'Utilidad'"
        :spanColumn="4"
        :data="prospect.Utilidad ? prospect.Utilidad : 'No informa'"
      ></custom-data>
    </el-row>
    <el-row :gutter="24">
      <custom-data
        :label="'Vendedor principal'"
        :spanColumn="8"
        :data="
          prospect.UsuarioVendedorPrincipal && prospect.UsuarioVendedorPrincipal.Codigo
            ? prospect.UsuarioVendedorPrincipal.Nombre +
              ' ' +
              prospect.UsuarioVendedorPrincipal.Apellido
            : 'No informa'
        "
      ></custom-data>
      <custom-data
        :label="'Vendedor secundario'"
        :spanColumn="8"
        :data="
          prospect.UsuarioVendedorSecundario && prospect.UsuarioVendedorSecundario.Codigo
            ? prospect.UsuarioVendedorSecundario.Nombre +
              ' ' +
              prospect.UsuarioVendedorSecundario.Apellido
            : 'No informa'
        "
      ></custom-data>
      <custom-data
        :label="'Clasificación'"
        :spanColumn="8"
        :data="
          prospect.Clasificacion && prospect.Clasificacion.Codigo
            ? prospect.Clasificacion.Descripcion
            : 'No informa'
        "
      ></custom-data>
    </el-row>
    <div
      class="section-title custom-label"
      style="margin-top: 12px"
    >
      Contactos
    </div>

    <template v-if="prospect?.Contactos?.length">
      <el-row :gutter="12">
        <el-col
          v-for="(c, i) in prospect.Contactos"
          :key="i"
          :span="24"
        >
          <el-card
            class="contact-card"
            shadow="never"
          >
            <el-row :gutter="20">
              <custom-data
                :label="'Nombre completo'"
                :spanColumn="6"
                :data="fullName(c) || '—'"
              ></custom-data>
              <custom-data
                :label="'Email'"
                :spanColumn="6"
                :data="c?.Email || '—'"
              ></custom-data>
              <custom-data
                :label="'Tel. principal'"
                :spanColumn="6"
                :data="c?.TelefonoPrincipal || '—'"
              ></custom-data>
              <custom-data
                :label="'Tel. secundario'"
                :spanColumn="6"
                :data="c?.TelefonoSecundario || '—'"
              ></custom-data>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </template>
    <el-empty
      v-else
      description="Sin contactos"
    />
  </detail-container>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useProspectStore } from '../stores/prospect_store.js';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
import getDate from '@/shared/components/utils.js';

const prospectStore = useProspectStore();
const { findProspectByCodigoHTTP } = prospectStore;
const { prospect } = storeToRefs(prospectStore);
const route = useRoute();
const router = useRouter();
// local state
const items = [
  { label: 'Inicio', to: '/page/prospects/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

function fullName(c) {
  if (!c) return '';
  const first = (c.Nombre || '').trim();
  const last = (c.Apellido || '').trim();
  return [first, last].filter(Boolean).join(' ');
}
const editItem = () => router.replace(`/page/prospects/edit/${route.params.id}`);

onBeforeMount(() => {
  const id = route.params.id;
  if (id && +id > 0) {
    findProspectByCodigoHTTP(id).then(() => {
      if (!Array.isArray(prospect.value.Contactos)) prospect.value.Contactos = [];
    });
  }
});
</script>

<style scoped></style>
